import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class CustomErrorMessageService {

  extractErrorMessage(error: any): string {
    // GraphQL (for both apollo.query() and apollo.watchQuery())
    const gqlError = error?.graphQLErrors?.[0]?.message ||
      error?.errors?.[0]?.message;
    if (gqlError) return gqlError;

    // REST
    if (error?.error?.message) return error.error.message;

    // Generic fallback
    return error?.message || 'Unknown error';
  }

  extractErrorCode(error: any): string | null {
    return error?.graphQLErrors?.[0]?.extensions?.errorCode ||
      error?.errors?.[0]?.extensions?.errorCode ||
      error?.error?.errorCode ||
      null;
  }

  extractAllErrors(error: any): string[] {
    const errors = [
      ...(error?.graphQLErrors?.map((e: any) => e.message) || []),
      ...(error?.errors?.map((e: any) => e.message) || [])
    ];
    return errors.length > 0 ? errors : [this.extractErrorMessage(error)];
  }

  extractFieldErrors(error: any): Record<string, string> | null {
    const validationErrors = error?.error?.validationErrors as { field: string, message: string }[];
    if (!validationErrors?.length) return null;

    return validationErrors.reduce((acc, e) => {
      acc[e.field] = e.message;
      return acc;
    }, {} as Record<string, string>);
  }
}